import { render } from "./ImagesTable.vue?vue&type=template&id=488f90d4&scoped=true"
import script from "./ImagesTable.vue?vue&type=script&lang=js"
export * from "./ImagesTable.vue?vue&type=script&lang=js"

import "./ImagesTable.vue?vue&type=style&index=0&id=488f90d4&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488f90d4"]])

export default __exports__
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPagination,QBtn,QCard,QImg,QCardSection,QBadge,QIcon,QSeparator,QCardActions});
